import React from 'react';
import PropTypes from 'prop-types';

const Test = ({ testCaptureException, testThrowError, testObjectError, testLogger }) => (
  <div className="layout u-mt+">
    <div className="layout__item  u-pl+ c-label-new">
      Sentry integration
    </div>
    <div className="layout__item  u-pl+">
      <button
        type="button"
        className="c-btn"
        onClick={testCaptureException}
      >
        Test Sentry captureException
      </button>
      <br/>
      <button
        type="button"
        className="c-btn u-mt"
        onClick={testThrowError}
      >
        Test Sentry capture thrown error
      </button>
      <br/>
      <button
        type="button"
        className="c-btn u-mt"
        onClick={testObjectError}
      >
        Test Sentry capture non-error object
      </button>
    </div>
    <div className="layout__item  u-pl+ c-label-new">
      Logger
    </div>
    <div className="layout__item  u-pl+">
      <button
        type="button"
        className="c-btn"
        onClick={testLogger}
      >
        Send test log
      </button>
    </div>
  </div>
);

Test.propTypes = {
  testCaptureException: PropTypes.func.isRequired,
  testThrowError: PropTypes.func.isRequired,
    testObjectError: PropTypes.func.isRequired,
    testLogger: PropTypes.func.isRequired,
  };

    export default Test;
